// extracted by mini-css-extract-plugin
module.exports = {"main-layout":"index_main-layout__Sc9ea"};